module.exports = __webpack_public_path__ + "img/sfks-2.10ed921c.png";